import { TicketAssignee } from './TicketAssignee';

export * from './TicketAssignee.types';
export { TicketAssignee };
export default TicketAssignee;
